// extracted by mini-css-extract-plugin
module.exports = {"avatar":"UserAvatar_avatar__7H-OK","initials":"UserAvatar_initials__1i_L3","icon":"UserAvatar_icon__29RaM"};